import clsx from 'clsx'

import { FvLinkButton, Icon } from '@fv/client-components'

import { DividedContent } from '@/components/DividedContent'

type SharePanelHeaderProps = {
  className?: string
  closePanel: () => void
}

const SharePanelHeader = ({ className, closePanel }: SharePanelHeaderProps) => {
  return (
    <DividedContent className={clsx(className)}>
      <FvLinkButton icon="arrow-to-left" onClick={closePanel}>
        Back
      </FvLinkButton>
      <div>
        <Icon icon="share" className="text-fv-gray-dark" />
        <span>Share this shipment</span>
      </div>
    </DividedContent>
  )
}

export default SharePanelHeader
